/** OpenRouter 全局集成契约：凭据只提交，读取仅返回凭据尾号。 */
import { z } from 'zod';

export const UpsertOpenRouterCredentialRequestSchema = z
  .object({
    api_key: z.string().trim().min(8).max(512).optional(),
  })
  .strict();
export type UpsertOpenRouterCredentialRequest = z.infer<
  typeof UpsertOpenRouterCredentialRequestSchema
>;
export type OpenRouterCredentialResponse = {
  configured: boolean;
  key_tail: string | null;
  last_verified_at: string | null;
  updated_at: string | null;
};
